/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  UserFlagsUserControllerFindManyQueryResponse,
  UserFlagsUserControllerFindMany401,
} from '../../types/UserFlagsUserControllerFindMany.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { userFlagsUserFindMany } from '../../methods/userFlagsUserFindMany.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const userFlagsUserFindManyQueryKey = () => [{ url: '/api/user/user-flags' }] as const;

export type UserFlagsUserFindManyQueryKey = ReturnType<typeof userFlagsUserFindManyQueryKey>;

export function userFlagsUserFindManyQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = userFlagsUserFindManyQueryKey();
  return queryOptions<
    UserFlagsUserControllerFindManyQueryResponse,
    ResponseErrorConfig<UserFlagsUserControllerFindMany401>,
    UserFlagsUserControllerFindManyQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return userFlagsUserFindMany(config);
    },
  });
}

/**
 * {@link /api/user/user-flags}
 */
export function useUserFlagsUserFindMany<
  TData = UserFlagsUserControllerFindManyQueryResponse,
  TQueryData = UserFlagsUserControllerFindManyQueryResponse,
  TQueryKey extends QueryKey = UserFlagsUserFindManyQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        UserFlagsUserControllerFindManyQueryResponse,
        ResponseErrorConfig<UserFlagsUserControllerFindMany401>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userFlagsUserFindManyQueryKey();

  const query = useQuery(
    {
      ...userFlagsUserFindManyQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<UserFlagsUserControllerFindMany401>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
